import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';

type ResponsePattern = {
  isSuccess: boolean;
  value: unknown;
  errors: unknown[];
  warnings: unknown[];
};

export const responseBodyInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    map((event) => {
      if (event instanceof HttpResponse) {
        const body = event.body;

        if (isBackendResultPatternBody(body)) {
          return event.clone({
            body: body.value,
          });
        }
      }

      return event;
    }),
  );
};

function isBackendResultPatternBody(body: unknown): body is ResponsePattern {
  return (
    typeof body === 'object' &&
    body !== null &&
    'isSuccess' in body &&
    'value' in body &&
    'errors' in body
  );
}
